import React from 'react';
import DetailedHeader from '../../../../components/ProjectDetailedPageComponents/DetailedHeader';
import ImageSlider from '../../../../components/Misc/ImageSlider';
import projectImage from '../../../../assets/images/work/sn-nex/NEX_slider_1.jpg';
import projectImage1 from '../../../../assets/images/work/sn-nex/NEX_slider_2.jpg';
import projectImage2 from '../../../../assets/images/work/sn-nex/NEX_slider_3.jpg';
import projectImage3 from '../../../../assets/images/work/sn-nex/NEX_slider_4.jpg';
import projectImage4 from '../../../../assets/images/work/sn-nex/NEX_slider_5.jpg';
import projectImage5 from '../../../../assets/images/work/sn-nex/NEX_slider_6.jpg';
import projectImage6 from '../../../../assets/images/work/sn-nex/NEX_slider_7.jpg';

import Data_SNNEX from './Data_SNNEX';

function Work_SNNEX() {
    return (
        <>
            <DetailedHeader
                heading="Designed to meet people where exploration happens"
                client="Science North"
                service="Platform"
                date="2025-Present"
            />
            <ImageSlider
                noArt="true"
                swiperNav="true"
                images={[
                    {
                        image: projectImage5,
                        alt: 'Project Image',
                    },
                    {
                        image: projectImage1,
                        alt: 'Project Image',
                    },
                    {
                        image: projectImage2,
                        alt: 'Project Image',
                    },
                    {
                        image: projectImage3,
                        alt: 'Project Image',
                    },
                    {
                        image: projectImage6,
                        alt: 'Project Image',
                    },
                    {
                        image: projectImage4,
                        alt: 'Project Image',
                    },
                     {
                        image: projectImage,
                        alt: 'Project Image',
                    },
                ]}
            />

            {Data_SNNEX.content}
        </>
    );
}

export default Work_SNNEX;
